<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import emblaCarouselVue from 'embla-carousel-vue'
import { pluralize } from '@/views/programs/checkup/utils/pluralize.js'

const props = defineProps(['programInfoSlider', 'programsSetup'])
defineEmits(['openProgramGroupsInfo'])

const [emblaRef] = emblaCarouselVue({ loop: false, align: 'start' })

const groupedPrograms = computed(() => {
  return props.programInfoSlider.reduce((acc, item) => {
    if (!acc[item.group_id]) {
      acc[item.group_id] = []
    }
    acc[item.group_id].push(item)
    return acc
  }, {})
})

function getPluralTitle (groupNumber, num) {
  const group = props.programsSetup.group_id.find(
    (g) => g.value === groupNumber
  )
  if (!group) return ''
  const plurals = group.plural
  return plurals?.[pluralize(num)] || ''
}
</script>

<template>
  <div class="slider-container">
    <div class="embla" ref="emblaRef">
      <div class="embla__container">
        <template v-for="(group, groupId) in groupedPrograms" :key="groupId">
          <div class="embla__slide">
            <p class="programs-title">
              {{ group.length }}
              {{ getPluralTitle(+groupId, group.length) }}
            </p>

            <ul>
              <li v-for="item in group.slice(0, 3)" :key="item.id">
                {{ item.title }}
              </li>
            </ul>

            <button
              class="program-sign-up__button--transparent"
              @click.prevent="
                $emit(
                  'openProgramGroupsInfo',
                  'open',
                  `${group.length} ${getPluralTitle(+groupId, group.length)}`,
                  group
                )
              "
            >
              Посмотреть все
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.programs-title {
  color: #002856;
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
}
.slider-container {
  overflow: hidden;
  margin-bottom: 24px;
}
.embla {
  margin: auto;
  --slide-height: 19rem;
  --slide-size: 90%;
}
.embla__viewport {
  overflow: hidden;
}
.embla__container {
  display: flex;
  touch-action: pan-y pinch-zoom;
  margin-left: calc(var(--slide-spacing) * -1);
  gap: 16px;
}
.embla__slide {
  transform: translate3d(0, 0, 0);
  flex: 0 0 var(--slide-size);
  min-width: 0;
  padding-left: var(--slide-spacing);

  max-width: 300px;
  min-height: 372px;
  border: 1px solid #bac7de;
  padding: 12px;

  display: flex;
  flex-direction: column;

  height: var(--slide-height);
  user-select: none;

  background-color: #fff;
}

ul {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 30px;
}

li {
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: $blue;
  line-height: 24px;
  list-style: none;
  position: relative;
  &::before {
    content: "";
    width: 3px;
    height: 3px;
    position: absolute;
    top: 10px;
    left: -12px;
    background-color: $blue;
    border-radius: 100%;
  }
}

.program-sign-up__button--transparent {
  font-size: 16px;
  font-weight: 400;
  line-height: 23.58px;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 30px;
  height: 50px;
  width: 100%;
  text-transform: uppercase;
  color: #002856;
  margin-top: auto;
  transition: all 0.2s ease;
  border: 1px solid #002856;
}
</style>
